import { RadiusCircleProps } from '../Map.interface';
import { Circle } from 'react-leaflet';
import { memo } from 'react';

const RadiusCircle = ({ location, radius = 1000 }: RadiusCircleProps) => {
	return (
		<Circle
			center={[location.latitude, location.longitude]}
			pathOptions={{
				color: '#20AC93',
				weight: 1,
				fillColor: 'rgba(32, 172, 147, 0.5)',
			}}
			radius={radius}
		/>
	);
};

export default memo(RadiusCircle, (prev, next) => {
	return (
		prev.location?.latitude === next.location?.latitude &&
		prev.location?.longitude === next.location?.longitude &&
		prev.radius === next.radius
	);
});
